import React, { Component } from 'react';
import Breadcrumbs from '../../../components/Breadcrumbs/Breadcrumbs';
import Skeleton from "../../../components/Skeleton/Skeleton";
import ContentPanel from "../../../components/ContentPanel/ContentPanel";
import ContentAccordion from "../../../components/ContentAccordion/ContentAccordion";

class InternationalCustoms extends Component {
  render() {
    return (
      <div className="wrapper">
        <Breadcrumbs/>
        <ContentPanel
          skeleton={<Skeleton type="MAIN_PANEL" />}
          errorTemplate={<Skeleton type="MAIN_PANEL_ERROR" />}
          templateUrl="./content/ship/page-components/text-block/international-customs-guidelines-heading.html"
        />
        <div className="mtl pbl">
          <ContentAccordion jsonDataUrl="./content/ship/page-components/accordion/international-customs-guidelines.json"/>
        </div>
      </div>
    );
  }
}

export default InternationalCustoms;



// WEBPACK FOOTER //
// ./src/pages/ship/GuidelinesAndTools/InternationalCustomsAndGuidelines.js